import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import JourneyProp from '../../journey/propTypes/journeyProp';

export default function JourneyItemInfo({ journey, isFlipped }) {
  const skills = (journey.skillLevels || [])
    .sort((s1, s2) => s2.level - s1.level)
    .slice(0, 6);

  return (
    <div className="col-lg-5 col-md-5 align-center">
      <h3 className="landing-journey-title">{journey.title}</h3>
      <hr
        className={cx({
          'divider-black': !isFlipped,
          'divider-black-left': isFlipped,
        })}
      />
      <div className="landing-journey-list">
        <p>{journey.summary || journey.description}</p>
        <div
          className={cx({
            'landing-journey-list-compet': true,
            'f-invert': isFlipped,
          })}
        >
          {skills.map(skill => (
            <div key={skill.name} className="landing-journey-list-compet-item">
              <p>{skill.name}</p>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${Math.round((skill.level / 6) * 100)}%` }}
                >
                  {skill.level}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

JourneyItemInfo.propTypes = {
  journey: PropTypes.shape(JourneyProp.propType).isRequired,
  isFlipped: PropTypes.bool,
};

JourneyItemInfo.defaultProps = {
  isFlipped: false,
};
